<template>
	<div class="full" style="background-color: white;position: relative;" v-loading="loading">
		<div style="width: 500px;">
			<div ref="relationshop"></div>
			<el-button size="mini" style="float: right;margin-top: 10px;" type="primary" @click="submit">保存</el-button>
		</div>
		<jindieextra ref="relationshopjindieextra" :type="jindieextratype" @submit="jindieSubmit" />
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<script>
	const formjson = {
		title: '表单',
		rule: {
			"width": "800",
			"height": "600",
			"fApi": [],
			"rule": [{
					"type": "el-divider",
					"children": [
						"万里牛信息"
					]
				},
				{
					"type": "$input",
					"field": "wln_id",
					"title": "万里牛ID",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$input",
					"field": "wln_name",
					"title": "万里牛名称",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "el-divider",
					"children": [
						"星空对应关系"
					]
				},
				{
					"type": "$inputButton",
					"field": "jindie_plantcode",
					"title": "平台编码",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "jindie_departmentcode",
					"title": "部门编码",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "jindie_zhifubao_bankaccount",
					"title": "支付宝银行账号【淘系】",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "jindie_yulibao_bankaccount",
					"title": "余利宝银行账号【淘系】",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "jindie_juhe_bankaccount",
					"title": "聚合银行账号【淘系】",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "jindie_wangshang_bankaccount",
					"title": "网商银行【淘系】",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "jindie_qiandaibao_bankaccount",
					"title": "钱袋宝【京东】",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
				{
					"type": "$inputButton",
					"field": "jindie_zhangfang_bankaccount",
					"title": "账房【拼多多】",
					"value": "",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				},
			],
			"option": {
				"form": {
					"labelWidth": "150px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					},
					"el-divider": {
						"wrap": {
							"show": false
						},
						"native": false,
						"col": {
							"span": 24,
							"offset": 0
						},
						"props": {
							"contentPosition": "left"
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	import jindieextra from './box/jindieextra'
	export default {
		props: {
			shop: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading: false,
				currentitem: null,
				emunid: 0,
				emuntTreeKey: Math.random(),
				parentbread: [],
				tableData: [],
				jindieextratype: [],
				currentfield: '',
			}
		},
		watch: {
			shop() {
				if (this.fApi) {
					this.fApi.resetFields()
					this.fApi.setValue('wln_id', this.shop.id)
					this.fApi.setValue('wln_name', this.shop.name)
					this.get()
				}

			}
		},
		created() {

		},
		mounted() {
			this.init()
		},
		computed: {

		},
		methods: {
			init() {
				let formData = JSON.parse(JSON.stringify(formjson))
				let rule = formData.rule.rule
				let option = formData.rule.option
				option.el = this.$refs.relationshop
				this.fApi = this.$formCreate(rule, option)
				this.fApi.nextTick(() => {
					this.regestevent(rule)
					this.setFormData()
					this.fApi.setValue('wln_id', this.shop.id)
					this.fApi.setValue('wln_name', this.shop.name)
					this.get()
				})
				this.$emit('show')
			},
			regestevent(rule) {
				rule.forEach((item) => {
					if (item.field) {
						let on = {}
						if (typeof this[item.field + 'Input'] === 'function') {
							on.input = this[item.field + 'Input']
						}
						if (typeof this[item.field + 'Change'] === 'function') {
							on.input = this[item.field + 'Change']
						}
						if (typeof this[item.field + 'Button'] === 'function') {
							on.inputButtonclick = this[item.field + 'Button']
						}
						this.fApi.updateRule(item.field, {
							on: on
						})
					}
				})
			},
			jindie_plantcodeButton() {
				this.currentfield = 'jindie_plantcode'
				this.jindieextratype = ['BD_Customer']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindie_departmentcodeButton() {
				this.currentfield = 'jindie_departmentcode'
				this.jindieextratype = ['BD_Department']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindie_zhifubao_bankaccountButton() {
				this.currentfield = 'jindie_zhifubao_bankaccount'
				this.jindieextratype = ['CN_BANKACNT']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindie_yulibao_bankaccountButton() {
				this.currentfield = 'jindie_yulibao_bankaccount'
				this.jindieextratype = ['CN_BANKACNT']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindie_juhe_bankaccountButton() {
				this.currentfield = 'jindie_juhe_bankaccount'
				this.jindieextratype = ['CN_BANKACNT']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindie_wangshang_bankaccountButton() {
				this.currentfield = 'jindie_wangshang_bankaccount'
				this.jindieextratype = ['CN_BANKACNT']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindie_qiandaibao_bankaccountButton() {
				this.currentfield = 'jindie_qiandaibao_bankaccount'
				this.jindieextratype = ['CN_BANKACNT']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindie_zhangfang_bankaccountButton() {
				this.currentfield = 'jindie_zhangfang_bankaccount'
				this.jindieextratype = ['CN_BANKACNT']
				this.$refs.relationshopjindieextra.initList()
				this.$refs.relationshopjindieextra.box.alertBox()
			},
			jindieSubmit(e) {
				if (e.data) {
					this.fApi.setValue(this.currentfield, e.data.FNumber)
				} else {
					this.fApi.setValue(this.currentfield, null)
				}
				// console.log(e)
			},

			setFormData() {
				if (this.sourceData) {
					let fields = this.fApi.fields()
					fields.forEach((item) => {
						this.fApi.setValue(item, this.sourceData[item])
					})
				}
			},
			submitDataFormater(formData) {
				for (let i in formData) {
					if (i.match(/^\$son/)) {
						for (let j in formData[i]) {
							formData[i][j].forEach((item) => {
								for (let k in item) {
									if (k.match(/.*time$/g)) {
										item[k] = item[k] / 1000
									}
								}
							})
						}
					} else if (i.match(/.*time$/g)) {
						console.log(i)
						formData[i] = formData[i] / 1000
					}
				}
			},
			get() {
				this.loading = true
				this.$api.platformmap.get(this.shop.id, {
					fromdatatype: 'shop',
					fromplant: 'wln',
					toplant: 'jindie',
				}).then((res) => {
					this.loading = false
					if (!res) {
						res = {
							todata: {},
						}
					}
					for(let i in res.todata){
						this.fApi.setValue(i, res.todata[i])
					}

				})
			},
			submit() {
				this.loading = true
				this.$api.platformmap.save({
					fromdataid: this.fApi.getValue('wln_id'),
					fromdatatype: 'shop',
					fromplant: 'wln',
					fromdata: {
						wln_id: this.fApi.getValue('wln_id'),
						wln_name: this.fApi.getValue('wln_name'),
					},
					toplant: 'jindie',
					todata: {
						jindie_plantcode: this.fApi.getValue('jindie_plantcode'),
						jindie_departmentcode: this.fApi.getValue('jindie_departmentcode'),
						jindie_zhifubao_bankaccount: this.fApi.getValue('jindie_zhifubao_bankaccount'),
						jindie_yulibao_bankaccount: this.fApi.getValue('jindie_yulibao_bankaccount'),
						jindie_juhe_bankaccount: this.fApi.getValue('jindie_juhe_bankaccount'),
						jindie_wangshang_bankaccount: this.fApi.getValue('jindie_wangshang_bankaccount'),
						jindie_qiandaibao_bankaccount: this.fApi.getValue('jindie_qiandaibao_bankaccount'),
						jindie_zhangfang_bankaccount: this.fApi.getValue('jindie_zhangfang_bankaccount')
					}

				}).then(() => {
					this.loading = false
					this.$message.success('操作成功')
				}, () => {
					this.loading = false
				})

			},
			emuntTreeChange(e) {
				this.currentitem = e
				this.emunid = e.id
				this.parentbread = e.parentbread
			},
		},
		components: {
			jindieextra
		}
	}
</script>